// <reference path="employee.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Controls {
    import LocationListItem = Meevo.Model.LocationListItem;
    import UserLocation = Meevo.Model.UserLocation;

    class ChangeHomeLocationModalController {

        static $inject = ['context', '$mdDialog' ];
        public context: any;
        public selectedUserLocation: UserLocation;

        constructor(context: any,
            private $mdDialog: angular.material.IDialogService
        )
        {
            this.context = context;

            this.selectedUserLocation = _.find(this.context.currentEmployee.userLocations,
                (a:UserLocation) => a.location.id === this.context.currentEmployee.homeLocationId);

        }

        apply = () => {
            this.context.currentEmployee.homeLocationId = this.selectedUserLocation.location.id;
            this.context.homeLocation = this.selectedUserLocation;
            this.context.locationId = this.selectedUserLocation.location.id;
            this.context.asLocationId = this.selectedUserLocation.location.id;
            this.$mdDialog.hide();
        }
        cancel = () => {
            this.$mdDialog.hide();
        }

    }

    angular.module('meevo.plugins.employee')
        .controller('meevo.plugins.employee.ChangeHomeLocationModalController', ChangeHomeLocationModalController);
}